import React, { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';
import { i18n } from '../../../translate/i18n';
import { isEmpty } from 'lodash';
import Checkbox from '@mui/material/Checkbox';
import * as actions from "../../../store/actions";
import { toastr } from 'react-redux-toastr'

import {
  Paper, Avatar, Container, Table, TableBody, TableCell, TableFooter, TablePagination, TableRow, Typography, Chip, Button, Drawer,
} from '@mui/material';

import iconSuitable from '../../../assets/certo.svg';
import iconNotSuitable from '../../../assets/erro.svg';
import iconNA from '../../../assets/meio.svg';
import FilterList from '@mui/icons-material/FilterList';
import Spinner from '../../../components/Spinner/index';
import EnhancedTableHead from "../../../UI/MaterialTableOverrides/EnhancedTableHead";
import TablePaginationActionsWrapped from "../../../UI/MaterialTableOverrides/TablePaginationActions";
import TableTitle from '../../../UI/MaterialTableOverrides/TableTitle';
import ServiceModalFilter from '../ModalFilter/Services/index'
import { formatLanguageFromLocalStorage } from '../../../utils/formatLanguageFromLocalStorage';
import ServiceCreationBlockedModal from "../../../components/ServiceCreationBlockedModal";
import { EAccessRole } from "../../../store/types";
import EFeatureFlags from "../../../utils/EFeatureFlags";

export default function TableEmpresas(props) {
  const dispatch = useDispatch();
  const textInput = useRef(null);

  const [page, setPage] = useState(1);
  const [alreadySerched, setAlreadySerched] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [limit, setLimit] = useState(5);
  const [searchText, setSearchText] = useState("");
  const [orderBy, setOrderBy] = useState("date");
  const [order, setOrder] = useState("desc");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [showServiceCreationBlockedModal, setShowServiceCreationBlockedModal] = useState(false);

  const selectedSites = useSelector(state => state.sites.selectedSitesPlaces);
  // Modal Filter
  const filteredPlaces = useSelector(state => state.services.filteredPlaces);
  const filteredAreas = useSelector(state => state.services.filteredAreas);
  const filteredModels = useSelector(state => state.services.filteredModels);
  const filteredGroups = useSelector(state => state.services.filteredGroups);
  const filteredCompanies = useSelector(state => state.services.filteredCompanies);
  const filteredServiceTypes = useSelector(state => state.services.filteredServiceTypes);
  const filteredFrequencies = useSelector(state => state.services.filteredFrequencies);
  const filteredUsers = useSelector(state => state.services.filteredUsers);
  const filteredStartDate = useSelector(state => state.services.startDate);
  const filteredEndDate = useSelector(state => state.services.endDate);
  const filteredEquipment = useSelector(state => state.services.filteredEquipment);
  const filteredSources = useSelector(state => state.services.filteredSources);
  const filteredDoneInDelay = useSelector(state => state.services.filteredDoneInDelay);

  const selectedAccess = useSelector(state => state.auth.selectedAccess);
  const isAnalyst = selectedAccess.role === EAccessRole.analyst;
  const isContractor = selectedAccess.role === EAccessRole.contractor;
  const onlyQRServicesFeatureFlag = selectedAccess.tenant.featureFlags.includes(EFeatureFlags.BLOCK_SERVICE_CREATION_WITHOUT_QRCODE_SCANNING);
  const blockServiceCreation = (onlyQRServicesFeatureFlag && (isAnalyst || isContractor));


  const fetchServices = useCallback(() => dispatch(actions.fetchServices(page, limit, "", order, orderBy, selectedSites, filteredPlaces, filteredAreas, filteredCompanies, filteredModels, filteredGroups, filteredServiceTypes, filteredFrequencies, filteredUsers, filteredStartDate, filteredEndDate, filteredEquipment, filteredSources, filteredDoneInDelay)),
    [page, limit, "", order, orderBy, selectedSites, filteredPlaces, filteredModels, filteredGroups, filteredServiceTypes, filteredCompanies, filteredFrequencies, filteredUsers, filteredStartDate, filteredEndDate, filteredEquipment, filteredSources, filteredAreas, filteredDoneInDelay]
  );

  const localStorageLang = localStorage.getItem("i18nextLng");
  const emailLanguage = formatLanguageFromLocalStorage(localStorageLang);

  // Export Excell
  const fetchServicesExport = useCallback(() => dispatch(actions.fetchServicesExport("", order, orderBy, selectedSites, filteredPlaces, filteredAreas, filteredCompanies, filteredModels, filteredGroups, filteredServiceTypes, filteredFrequencies, filteredUsers, filteredStartDate, filteredEndDate, filteredEquipment,filteredSources, filteredDoneInDelay, emailLanguage)),
    ["", order, orderBy, selectedSites, filteredPlaces, filteredAreas, filteredModels, filteredGroups, filteredServiceTypes, filteredCompanies, filteredFrequencies, filteredUsers, filteredStartDate, filteredEndDate, filteredEquipment, filteredSources, filteredDoneInDelay, emailLanguage]
  );

  const services = useSelector(state => state.services.services);
  const servicesFilter = useSelector(state => state.services.servicesFilter);
  const loading = useSelector(state => state.services.loading);
  const selectedServices = useSelector(state => state.services.servicesSelected);

  const headRows = [
    { id: "date", numeric: false, disablePadding: false, label: i18n.t('headRowsManagementService.date') },
    { id: "equipment.equipmentModel.name", numeric: false, disablePadding: false, label: i18n.t('headRowsManagementService.equipmentEquipmentParamName') },
    { id: "equipmentService.serviceType.name", numeric: false, disablePadding: false, label: i18n.t('headRowsManagementService.inspection') },
    { id: "questions", numeric: false, disablePadding: false, label: i18n.t('headRowsManagementService.questions') },
    { id: "place.path", numeric: false, disablePadding: false, label: i18n.t('headRowsManagementService.placeName') },
    { id: "inspectedBy.name", numeric: false, disablePadding: false, label: i18n.t('headRowsManagementService.user') },
    { id: "description", numeric: false, disablePadding: false, label: i18n.t('headRowsManagementService.description') },
    { id: "checklistScoreFloat", numeric: false, disablePadding: false, label: i18n.t('headRowsManagementService.score') },
  ];

	useEffect(() => {
		dispatch(actions.setOpenDrawer(true))
	}, [])

  useEffect(() => {
    if (!isEmpty(servicesFilter)) {
      setPage(servicesFilter.page);
      setLimit(servicesFilter.limit);
      setOrderBy(servicesFilter.orderBy);
      setOrder(servicesFilter.order);
    }

    if (selectedServices) {
      setSelected(selectedServices);
    }
    setFirstLoad(false);
  }, []);

  useEffect(() => {
    if (!firstLoad) {
      fetchServices(page, limit, "", order, orderBy, selectedSites, filteredPlaces, filteredAreas, filteredCompanies, filteredModels, filteredGroups, filteredServiceTypes, filteredFrequencies, filteredUsers, filteredStartDate, filteredEndDate);
      setAlreadySerched(true);
    }
  }, [firstLoad, page, limit, order, orderBy])

  useEffect(() => {
    if (!firstLoad) {
      setPage(1);
      fetchServices(page, limit, "", order, orderBy, selectedSites, filteredPlaces, filteredAreas, filteredCompanies, filteredModels, filteredGroups, filteredServiceTypes, filteredFrequencies, filteredUsers, filteredStartDate, filteredEndDate);
      setAlreadySerched(true);
      handleEmptySelected();
    }
  }, [selectedSites, filteredPlaces, filteredAreas, filteredCompanies, filteredModels, filteredGroups, filteredServiceTypes, filteredFrequencies, filteredUsers, filteredStartDate, filteredEndDate, filteredEquipment, filteredSources, filteredDoneInDelay]);

  useEffect(() => {
    if (!firstLoad) {
      dispatch(actions.setServicesSelected(selected));
    }
  }, [selected]);

  const handleChangePage = (e, page) => {
    setPage(page + 1);
    handleEmptySelected();
  };

  const handleChangeRowsPerPage = e => {
    setLimit(e.target.value);
    setPage(1);
    handleEmptySelected();
  };

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === "desc";
    setOrder(isDesc ? "asc" : "desc");
    setOrderBy(property);
    handleEmptySelected();
  };

  const selectRow = (e, id) => {
    dispatch(actions.clearServiceForm())
    props.history.push(`/form-edit-service/${id}`)
  }

  const styles = {
    table: {
      position: 'relative',
      marginBottom: 50,
    },
    tableRow: {
      cursor: 'pointer',
    },
    opacityContainer: {
      opacity: loading ? '0.3' : '1',
    },
    spinner: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      top: '-5px',
      opacity: '1',
      zIndex: 2,
    },
    noResults: {
      height: '100px',
    },
    deleteTextConfirm: {
      marginLeft: '-30px',
      fontWeight: 'bold',
    },
    editWidth: {
      width: '90%'
    },
    avatarContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    thumbUp: {
      color: "#349c34"
    },
    thumbDown: {
      color: "#d04545"
    },
    avatar: {
      width: '2.75rem',
      height: '2.75rem',
      marginRight: '0.25rem',
    },
    avatarSmallText: {
      fontSize: '0.75rem',
      width: '2.75rem',
      height: '2.75rem',
      marginRight: '0.25rem',
    },
    chip: {
      margin: 5,
    },
    cell: {
      fontSize: '0.775rem',
      padding: '0.25rem',
    },
    cellPhotoContainer: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
    },
    ansContainer: {
      display: 'flex',
    },
    ansContent: {
      display: 'flex',
      alignItems: 'center',
      marginRight: '0.5rem',
    },
    iconChecklist: {
      width: '1.25rem',
      marginRight: '0.25rem',
    },
    buttonFilterContainer: {
      display: 'flex',
      flexDirection: 'row',
      padding: '0px 20px 10px 20px',
    },
    buttonFilterIcon: {
      marginLeft: 5
    },
    buttonFilter: {
      zIndex: 200,
      backgroundColor: 'green',
      height: '2.2rem',
      width: '6.5rem',
      padding: '1rem',
      color: '#fff',
    },
    clearFilter: {
      cursor: 'pointer',
      textDecoration: 'underline',
      zIndex: 200,
      padding: '0.75rem 0.5rem',
      color: '#000',
    },
    filterContainer: {
      position: 'relative',
      width: '100%',
    },
    filterChipContainer: {
      paddingLeft: 20,
      display: 'flex',
      flexWrap: 'wrap',
    },
    filterChip: {
      cursor: 'pointer',
      margin: 5,
    }
  }

  const deleteFilteredSite = (site) => {
    dispatch(actions.deleteFilteredSite(site))
  }

  const deleteFilteredPlaces = (place) => {
    dispatch(actions.filterServicePlacesRemove(place))
  }

  const deleteFilteredAreas = (area) => {
    dispatch(actions.filterServiceAreasRemove(area))
  }

  const deleteFilteredCompanies = (company) => {
    dispatch(actions.filterServiceCompaniesRemove(company))
  }

  const deleteFilteredServiceTypes = (serviceType) => {
    dispatch(actions.filterServiceServiceTypesRemove(serviceType))
  }

  const deleteFilteredFrequency = (frequency) => {
    dispatch(actions.filterServiceFrequenciesRemove(frequency))
  }

  const deleteFilteredUser = (user) => {
    dispatch(actions.filterServiceUsersRemove(user))
  }

  const deleteFilteredModels = (model) => {
    dispatch(actions.filterServiceModelsRemove(model))
  }

  const deleteFilteredGroups = (group) => {
    dispatch(actions.filterServiceGroupsRemove(group))
  }

  const deleteFilteredStartDate = () => {
    dispatch(actions.filterServiceStartDateRemove())
  }

  const deleteFilteredEndDate = () => {
    dispatch(actions.filterServiceEndDateRemove())
  }

  const deleteFilteredEquipment = () => {
    dispatch(actions.servicesTableFiltersSetSelectedEquipment(null));
  }

  const deleteFilteredSource = (source) => {
    const newSources = filteredSources.filter((filteredSource) => filteredSource.value !== source.value);
    dispatch(actions.filterServiceSources(newSources));
  }

  const deleteFilteredDoneInDelay = () => {
    dispatch(actions.filterServiceDoneInDelay(false));
  }

  const clearFilterButton = () => {
    if ((filteredServiceTypes && filteredServiceTypes.length > 0)
      || (filteredPlaces && filteredPlaces.length > 0)
      || (filteredAreas && filteredAreas.length > 0)
      || (filteredModels && filteredModels.length > 0)
      || (filteredGroups && filteredGroups.length > 0)     
      || (filteredFrequencies && filteredFrequencies.length > 0)
      || (filteredCompanies && filteredCompanies.length > 0)
      || (filteredEquipment)
      || (filteredStartDate)
      || (filteredEndDate)
      || (filteredSources && filteredSources.length > 0)
      || (filteredDoneInDelay))
      return <Typography onClick={handleClickClearFilters} style={styles.clearFilter}>{i18n.t('btnClearFilterManagementService.Typography')}</Typography>;
  };

  const renderSitesChips = () => (selectedSites && selectedSites.map((site) => (<Chip
    key={site._id}
    label={site.name}
    onDelete={() => deleteFilteredSite(site)}
    style={styles.filterChip} />)))
  const renderPlacesChips = () => (filteredPlaces && filteredPlaces.map((place) => (<Chip
    key={place.value}
    label={place.label}
    onDelete={() => deleteFilteredPlaces(place)}
    style={styles.filterChip} />)))
  const renderAreasChips = () => (filteredAreas && filteredAreas.map((area) => (<Chip
    key={area.value}
    label={area.label}
    onDelete={() => deleteFilteredAreas(area)}
    style={styles.filterChip} />)))
  const renderCompaniesChips = () => (filteredCompanies && filteredCompanies.map((company) => (<Chip
    key={company.value}
    label={company.label}
    onDelete={() => deleteFilteredCompanies(company)}
    style={styles.filterChip} />)))
  const renderServiceTypesChips = () => (filteredServiceTypes && filteredServiceTypes.map((serviceType) => (<Chip
    key={serviceType.value}
    label={serviceType.label}
    onDelete={() => deleteFilteredServiceTypes(serviceType)}
    style={styles.filterChip} />)))
  const renderFrequenciesChips = () => (filteredFrequencies && filteredFrequencies.map((frequency) => (<Chip
    key={frequency.value}
    label={frequency.label}
    onDelete={() => deleteFilteredFrequency(frequency)}
    style={styles.filterChip} />)))
    const renderUsersChips = () => (filteredUsers && filteredUsers.map((user) => (<Chip
      key={user.value}
      label={user.label}
      onDelete={() => deleteFilteredUser(user)}
      style={styles.filterChip} />)))
  const renderModelsChips = () => (filteredModels && filteredModels.map((model) => (<Chip
    key={model.value}
    label={model.label}
    onDelete={() => deleteFilteredModels(model)}
    style={styles.filterChip} />)))
  const renderGroupsChips = () => (filteredGroups && filteredGroups.map((group) => (<Chip
    key={group.value}
    label={group.label}
    onDelete={() => deleteFilteredGroups(group)}
    style={styles.filterChip} />)))
  const renderStartDateChip = () => (filteredStartDate && <Chip
    label={`De: ${moment(filteredStartDate).format('DD/MM/YYYY')}`}
    onDelete={() => deleteFilteredStartDate()}
    style={styles.filterChip} />)
  const renderEndDateChip = () => (filteredEndDate && <Chip
    label={`Até: ${moment(filteredEndDate).format('DD/MM/YYYY')}`}
    onDelete={() => deleteFilteredEndDate()}
    style={styles.filterChip} />)

  const renderEquipmentChip = () => (filteredEquipment && (<Chip
    key={filteredEquipment.value}
    label={`${filteredEquipment.label} ${i18n.t('scheduledServicesDraggableCard.serialNumber')}${filteredEquipment.equipment.serialNumber}`}
    onDelete={() => deleteFilteredEquipment()}
    style={styles.filterChip} />)
  )

  const renderSourcesChips = () => (filteredSources && filteredSources.map((source) => (<Chip
  key={source.value}
  label={source.label}
  onDelete={() => deleteFilteredSource(source)}
  style={styles.filterChip} />)))

  const renderDoneInDelayChip = () => (filteredDoneInDelay && <Chip
    label={i18n.t('autocompleteModalFilterService.doneInDelay')}
    onDelete={() => deleteFilteredDoneInDelay()}
    style={styles.filterChip} />)

  const handleClickClearFilters = useCallback(() => dispatch(actions.filterServiceClear()));

  const exportExcel = () => {
    setExportLoading(true);

    toastr.info('Info', i18n.t('tableTitleManagementService.excelGenerateToaster'))

    fetchServicesExport()
      .then(response => {
        if (response) {
          window.open(response.url, "_blank")
        }
        setExportLoading(false);
      })
      .catch(() => setExportLoading(false))
  }

  const selectAll = () => {
    if (services.rows) {
      if (selected && selected.length !== services.rows.length) {
        const aux = services.rows.map(el => el._id);
        setSelected(aux);
      } else {
        setSelected([]);
      }
    }
  };

  const checkboxChange = (item, value) => {
    if (selected) {
      const aux = [...selected];
      if (selected.indexOf(item) === -1) {
        aux.push(item);
        setSelected(aux);
      } else {
        aux.splice(selected.indexOf(item), 1);
        setSelected(aux);
      }
    }
  };

  const isItemSelected = (item) => {
    return selected && selected.indexOf(item) !== -1;
  };

  const handleEmptySelected = () => {
    setSelected([]);
  };

  const handleAddRow = () => {
    if (blockServiceCreation) {
      setShowServiceCreationBlockedModal(true);
    } else {
      dispatch(actions.clearServiceForm());
      props.history.push( "/form-new-service/0")
    }
  }

  return <>
    <Drawer
      variant="temporary"
      anchor="right"
      onClose={() => setIsFilterOpen(false)}
      open={isFilterOpen}>
      <ServiceModalFilter
        closeModal={() => setIsFilterOpen(false)}
      />
    </Drawer>
    <Container maxWidth="xl">
      <ServiceCreationBlockedModal
        show={showServiceCreationBlockedModal}
        close={() => setShowServiceCreationBlockedModal(false)}
      />
      <Paper>
        <TableTitle
          title={i18n.t('tableTitleManagementService.title')}
          placeholder={i18n.t('tableTitleManagementService.placeholder')}
          inputRef={textInput}
          value={searchText}
          onChange={event => {
            setPage(1);
            setSearchText(event.target.value);
          }}
          addRow={handleAddRow}
          addRowLabel={i18n.t('tableTitleManagementService.addRowLabel')}
          clickExport={exportExcel}
          downloading={exportLoading}
          exportButtonDisabled={loading}
          zipServiceReportDisabled={selected.length === 0 || selected.length > 10 }
          zipServiceReport
          addFromExcel={() => props.history.push('massive-import/service')}
          hideSearchInput
        />
        <div style={styles.filterChipContainer}>
          <Button
            variant='contained'
            onClick={() => setIsFilterOpen(true)}
            style={styles.buttonFilter}>
          {i18n.t('btnManagementService.label')} <FilterList style={styles.buttonFilterIcon} />
          </Button>
          {renderEquipmentChip()}
          {renderSitesChips()}
          {renderModelsChips()}
          {renderGroupsChips()}
          {renderPlacesChips()}
          {renderAreasChips()}
          {renderCompaniesChips()}
          {renderServiceTypesChips()}
          {renderFrequenciesChips()}
          {renderSourcesChips()}
          {renderDoneInDelayChip()}
          {renderUsersChips()}
          {renderStartDateChip()}
          {renderEndDateChip()}
          {clearFilterButton()}
        </div>
        <Table style={styles.table}>
          <tbody>
            <tr>
              <td>
                {loading &&
                  <div style={styles.spinner}>
                    <Spinner />
                  </div>}
                {services.rows.length === 0 &&
                  <div style={styles.noResults}>
                    {!loading && <Typography style={styles.spinner}>{i18n.t('btnManagementService.Typography')}</Typography>}
                  </div>}
              </td>
            </tr>
          </tbody>
          <EnhancedTableHead
            style={styles.opacityContainer}
            headRows={headRows}
            order={order ? order : 'desc'}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            checkbox
            onSelectAllClick={selectAll}
            numSelected={selected ? selected.length : 0}
            rowCount={services.rows ? services.rows.length : 0}
          />
          <TableBody style={styles.opacityContainer}>
            {services.rows.map((serv, index) => (
              <TableRow
                style={styles.tableRow}
                key={serv._id}
                hover
                onClick={event => selectRow(event, serv._id)}
              >
                <TableCell padding="checkbox" onClick={(e) => e.stopPropagation()}>
                  <Checkbox
                    checked={isItemSelected(serv._id)}
                    onChange={(e) => checkboxChange(serv._id, e.target.checked)}
                  />
                </TableCell>
                <TableCell style={{ ...styles.cell, paddingLeft: '1rem' }}>{moment(serv.date).format('DD/MM/YYYY')}</TableCell>
                <TableCell style={styles.cell}>
                  <div style={styles.cellPhotoContainer}>
                    {serv.equipment.photo ?
                      <Avatar src={serv.equipment.photo.url} style={styles.avatar} /> : <Avatar style={styles.avatarSmallText}>{i18n.t('tableCellManagementService.photo')}</Avatar>}

                    <div>
                      <div>{serv.equipment?.equipmentModel?.name}</div>
                      <div style={{ color: 'grey' }}>{serv.equipment.serialNumber}</div>
                    </div>
                  </div>
                </TableCell>
                <TableCell style={styles.cell}>
                  {serv.equipmentService.serviceType.name}{' '}({serv.equipmentService.frequency.name})
                </TableCell>
                <TableCell style={styles.cell}>
                  <div style={styles.ansContainer}>
                    <div style={styles.ansContent}>
                      <img src={iconSuitable} style={styles.iconChecklist} />
                      <div>{serv.questions.filter(ans => ans.type === 'question' && ans.answer === 'YES').length}</div>
                    </div>
                    <div style={styles.ansContent}>
                      <img src={iconNotSuitable} style={styles.iconChecklist} />
                      <div>{serv.questions.filter(ans => ans.type === 'question' && ans.answer === 'NO').length}</div>
                    </div>
                    <div style={styles.ansContent}>
                      <img src={iconNA} style={styles.iconChecklist} />
                      <div>{serv.questions.filter(ans => ans.type === 'question' && ans.answer === 'NA').length}</div>
                    </div>
                  </div>
                </TableCell>
                <TableCell style={styles.cell}>{serv.place.path}</TableCell>
                <TableCell style={styles.cell}>
                  <div style={styles.cellPhotoContainer}>
                    {<Avatar style={styles.avatarSmallText}>{i18n.t('tableCellManagementService.photo')}</Avatar>}
                    <div>{serv.inspectedBy.name}</div>
                  </div>
                </TableCell>
                <TableCell style={styles.cell}>{serv.description}</TableCell>
                <TableCell style={styles.cell}>{serv.checklistScoreFloat ? serv.checklistScoreFloat.toString() + '%' : serv.checklistScoreFloat === 0 ? '0%' : '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter style={styles.opacityContainer}>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                count={services.count}
                rowsPerPage={parseInt(limit)}
                page={page - 1}
                SelectProps={{
                  native: true
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActionsWrapped}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Paper>
    </Container>
  </>;
}
